import { compose, mount, route } from 'navi';
import React from 'react';
import PageNotFound from '.';

export default compose(
  mount({
    '/': route(() => ({ view: <PageNotFound /> })),
  }),
);
